export default "__VITE_ASSET__CxRYbTQg__"